module.exports = __webpack_public_path__ + "static/egr_static_banner-4d4f1bb597b7f833f09d74d2a57dd912.jpg";